import {BaseView} from '../core/view';

export default BaseView.extend({

    events: {
        "click .js-hscroll-left": "onScrollLeft",
        "click .js-hscroll-right": "onScrollRight"
    },

    initialize: function () {
        this.scrollItem = this.el.querySelector('.scrollable__item');
        this.scrollWindow = this.el.querySelector('.scrollable__window');
        this.scrollWindow.addEventListener('scroll', this.onScroll.bind(this));
        window.addEventListener('resize', this.onResize.bind(this));

        setTimeout(this.onScroll.bind(this), 500);
        setTimeout(this.onResize.bind(this), 500);
    },

    onScrollLeft: _.throttle(function () {
        let scrollPosition = (this.getScrollIndex() - 1) * this.scrollItem.getBoundingClientRect().width;
        $(this.scrollWindow).animate({ scrollLeft: scrollPosition }, '200');
    }, 200),

    onScrollRight: _.throttle(function () {
        this.loadImages();
        let scrollPosition = (this.getScrollIndex() + 1) * this.scrollItem.getBoundingClientRect().width;
        $(this.scrollWindow).animate({ scrollLeft: scrollPosition }, '200');
    }, 200),

    loadImages: _.once(function(){
        const images = this.scrollWindow.querySelectorAll('.lazy-image[src=""]');
        Array.prototype.forEach.call(images, image => {
            image.src = image.getAttribute('data-original');
        });
    }),

    onScroll: _.throttle(function () {
        let scrollLeftMax = this.scrollWindow.scrollWidth - this.scrollWindow.getBoundingClientRect().width;

        //scrolling left
        if (this.scrollWindow.scrollLeft >= scrollLeftMax) {
            this.el.classList.add("hscroll--disable-right");
        }
        else {
            this.el.classList.remove("hscroll--disable-right");
        }

        //scrolling right
        if (this.scrollWindow.scrollLeft <= 0) {
            this.loadImages();
            this.el.classList.add("hscroll--disable-left");
        }
        else {
            this.el.classList.remove("hscroll--disable-left");
        }
    }, 200),
    
    onResize: _.throttle(function () {
        let disableScroll = this.scrollWindow.getBoundingClientRect().width >= this.scrollWindow.scrollWidth;
        if (disableScroll) { this.el.classList.add("hscroll--disabled"); } 
        else { this.el.classList.remove("hscroll--disabled"); }
    }, 300),

    getScrollIndex: function() {
        return Math.floor(this.scrollWindow.scrollLeft / this.scrollItem.getBoundingClientRect().width);
    }
});